<template>
  <el-menu-item v-if="menu" class="menu-item" :index="menu.name">
    <menu-icon class="q-pr-sm" :menu="menu" />
    <template #title>
      <menu-title :menu="menu" :collapse="collapse" />
    </template>
  </el-menu-item>
</template>

<script setup lang="ts">
import { computed, ref, useHostAppInstance } from '@zto/zpage'
import { ElementPlusIcons } from '@zto/zpage-ui-element'

import MenuTitle from './menu-title.vue'
import MenuIcon from './menu-icon.vue'

const { MoreFilled } = ElementPlusIcons

const props = withDefaults(
  defineProps<{
    menu?: any
    collapse?: boolean
  }>(),
  {
    collapse: false
  }
)

const emit = defineEmits(['remove'])

const app = useHostAppInstance()

const dropdownRef = ref<any>()

const currentMenu = computed(() => {
  return props.menu || []
})

const isFolder = computed(() => {
  return currentMenu.value.isFolder === true
})

const menuLabel = computed(() => {
  const menu = currentMenu.value
  return isFolder.value ? menu.folderName : menu.itemName
})

function handleDropdownCommand(command: string) {
  switch (command) {
    case 'rename':
      handleRename()
      break
    case 'remove':
      handleRemove()
      break
    case 'addChild':
      handleAddChild()
      break
  }
}

async function handleRename() {
  const result = await app.ui.showMessageBox({
    boxType: 'prompt',
    title: '重命名',
    message: '请输入新的文件夹名称'
  })

  if (!result.value) return

  props.menu.title = result.value
}

async function handleRemove() {
  await app.ui.showMessageBox({
    boxType: 'confirm',
    title: '提示',
    message: '确认要删除该收藏吗？'
  })

  emit('remove', props.menu)
}

async function handleAddChild() {
  const result = await app.ui.showMessageBox({
    boxType: 'prompt',
    title: '新建子文件夹',
    message: '请输入子文件夹名称'
  })

  if (!result.value) return
}
</script>

<style lang="scss" scoped>
.menu-item {
  display: flex;
  align-items: center;
}
</style>
